/*** IMPORTS FROM imports-loader ***/
var shim = require("es5-shim/es5-shim");
var sham = require("es5-shim/es5-sham");

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = function () {
    function Barrage() {
        (0, _classCallCheck3["default"])(this, Barrage);

        _scope.Feature.EventBus(this);

        // _scope.Feature.Room(this, () => {
        //     rop.On('comment-stream-' + this.Room.act_id, function (data) {
        //         _scope.MsgBus.Pub('Barrage.New', data);
        //     });
        // });

        // this.destroyKey = _scope.MsgBus.Sub('Destroy', () => {
        //     rop.Remove('comment-stream-' + this.Room.act_id);
        //     _scope.MsgBus.UnSubAll('Barrage.New');
        //     _scope.MsgBus.UnSub(this.destroyKey);
        // });
    }

    (0, _createClass3["default"])(Barrage, [{
        key: "Placeholder",
        value: function Placeholder() {}
    }]);
    return Barrage;
}();



/*****************
 ** WEBPACK FOOTER
 ** ./~/es3ify-loader!./~/imports-loader?shim=es5-shim/es5-shim&sham=es5-shim/es5-sham!./~/babel-loader/lib!./application/components/core/Barrage.js
 ** module id = 172
 ** module chunks = 1
 **/